'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { CommunityChat } from '@features/user/communityChat';

import styles from './Footer.module.scss';

const Footer = () => {
  const t = useTranslations('navigation');

  return (
    <footer className={styles.footer}>
      <div className={styles.scope}>
        <div>Copyright © 2025 Q:EDU. All rights reserved.</div>

        <div className={styles.links}>
          <Link href="/terms-and-conditions" className={styles.link}>
            {t('termsAndConditions')}
          </Link>

          <Link href="/privacy-policy" className={styles.link}>
            {t('privacyPolicy')}
          </Link>
        </div>
      </div>

      <CommunityChat />
    </footer>
  );
};

export default Footer;
